import { useEffect, useState } from 'react'

function usePageAccumulator<T>(pageNum: number, data: T[]) {
  const [accumulatedData, setAccumulatedData] = useState<T[]>([])
  const [maxPageReached, setMaxPageReached] = useState(0)

  useEffect(() => {
    // If the page number is zero we're either loading for the first time,
    // or a filter change has occurred.  In either case, clear the accumulated
    // data and present only one page
    if (pageNum === 0) {
      setMaxPageReached(0)
      setAccumulatedData([...data])
    }

    // If we have not yet accumulated (and displayed) all records, append
    // another page to the accumulated data
    if (pageNum > 0 && pageNum > maxPageReached) {
      setMaxPageReached(pageNum)
      setAccumulatedData((oldAccumulatedData) => {
        return [...oldAccumulatedData, ...data]
      })
    }
  }, [data])

  return accumulatedData
}

export default usePageAccumulator
